export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/api/auth/login',
  REGISTER: '/api/auth/register',
  LOGOUT: '/api/auth/logout',
  ME: '/api/auth/me',

  // Prompts
  PROMPTS: '/api/prompts',
  PROMPTS_DEFAULT: '/api/prompts/default',
  PROMPT_BY_ID: (id: string) => `/api/prompts/${id}`,

  // Feeds
  FEEDS: '/api/feeds',
  FEEDS_TEST: '/api/feeds/test',
  FEED_BY_ID: (id: string) => `/api/feeds/${id}`,

  // Jobs
  JOBS: '/api/jobs',
  JOB_BY_ID: (id: string) => `/api/jobs/${id}`,
  JOB_PROGRESS: (id: string) => `/api/jobs/${id}/progress`,
  JOB_RESULTS: (id: string) => `/api/jobs/${id}/results`,
  JOB_STATS: '/api/jobs/stats',

  // Cost Tracking
  COST_STATS: '/api/stats/cost',
};
